import React from "react";
import NotInformation from "../../../../components/NotInformation";
import SearchSimple from "../../../../components/SearchSimples/SearchSimple";
import ResidentAssignedCard from "./ResidentAssignedCard";
import { ResidentsWhiteListApp } from "../../Functionality/ResidentsWhiteListApp";

/**
 * @Author: karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer
 * @Email : kpozos@ibl.mx
 *
 * White list of the building detail, same card grid as the registered tab but
 * without the verification chip, the entries carry no status yet.
 *
 * @param {Object} props.buildingDetail - Building the white list belongs to.
 * @param {number} props.refresh - Counter bumped by the add modal to reload the list.
 * @param {Function} props.onTotalChange - Reports the total of the list to the badge of the tab.
 */
const ResidentsWhiteList = ({ buildingDetail, refresh, onTotalChange }) => {
    const {
        t,
        option,
        searchElement,
        setSearchElement,
        results,
        setResults,
        rowsPerPage,
        setSearch,
        setSimpleSearch,
        setBodyForExport,
        handleSearch,
        handleResetSearch,
        pagination,
        elementRef
    } = ResidentsWhiteListApp({ buildingId: buildingDetail?.id, refresh, onTotalChange });

    return (
        <>
            <div className="row my-4 flex-shrink-0">
                <div className={"col-12 px-0"}>
                    <SearchSimple
                        id={"txt_rwl_search_simple"}
                        label={'search_by_name_email_or_apartment'}
                        searchElement={searchElement}
                        setSearchElement={setSearchElement}
                        optionTable={option}
                        rowsPerPage={rowsPerPage}
                        setSearchResults={setResults}
                        setBodyForExport={setBodyForExport}
                        setSearch={setSearch}
                        setSimpleSearch={setSimpleSearch}
                        callApi={handleSearch}
                        resetApi={handleResetSearch}
                    />
                </div>
            </div>

            {results?.content?.length > 0 ? (
                <>
                    <div className={"panelTables-container custom-scrollbar"} ref={elementRef}>
                        <div className={"row"}>
                            {
                                results?.content?.map((resident, index) => (
                                    // The entries of the white list have no id and the same email
                                    // can be authorized in more than one apartment, the position
                                    // is what keeps the key of the card unique
                                    <div className='col-12 col-md-6 mb-3 px-1' key={`${resident?.email}-${resident?.apartment}-${index}`}>
                                        <ResidentAssignedCard
                                            keyId={'email'}
                                            item={resident}
                                        />
                                    </div>
                                ))
                            }
                        </div>
                    </div>

                    <div className={"flex-shrink-0"}>
                        {pagination()}
                    </div>
                </>
            ) : (
                <NotInformation
                    text={searchElement === "" ? t('you_have_not_added_any_resident_to_the_white_list_yet') : t("no_results_found")}
                    card={true}
                    className={"h-100"}
                />
            )}
        </>
    );
};

export default ResidentsWhiteList;
